import { call, put, takeEvery } from "redux-saga/effects";
import { CorrectionConstants } from "../constants/correction.constants";
import {
    submitCorrectionSuccess,
    submitCorrectionFailure,
    submitCommentSuccess,
    submitCommentFailure,
    deleteCorrectionSuccess,
    deleteCorrectionFailure,
    reportCorrectionSuccess,
    reportCorrectionFailure
} from "../actions/correction.actions";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import Query from "../utils/graphqlQueryBuilder";
import { jsToCorrectionRecord } from "../records/post.record";

export function* submitCorrection() {
    yield takeEvery(CorrectionConstants.SUBMIT_CORRECTION, doSubmitCorrection);
}

export function* submitComment() {
    yield takeEvery(CorrectionConstants.SUBMIT_COMMENT, doSubmitComment);
}

export function* deleteCorrection() {
    yield takeEvery(CorrectionConstants.DELETE_CORRECTION, doDeleteCorrection);
}

export function* reportCorrection() {
    yield takeEvery(CorrectionConstants.REPORT_CORRECTION, doReportCorrection);
}

function commentFindContents() {
    return [
        "id",
        "postId",
        "body",
        "reportedUsers",
        {
            author: [
                "id",
                "displayName",
                "avatarURL",
                {
                    languages: ["isLearning", "level", "language"]
                }
            ]
        },
        "authorId",
        "comment",
        "creationDate",
        "lastUpdateDate",
        {
            edits: ["id", "correctionId", "startIndex", "length", "newText"]
        }
    ];
}

function* doSubmitComment({ payload: { post, text } }) {
    try {
        const correction = yield call(doSubmitCorrectionQuery, {
            body: "",
            edits: [],
            postId: post.id,
            comment: text.trim()
        });
        yield put(submitCommentSuccess({ correction }));
    } catch (e) {
        yield call(handleFailure, e, submitCommentFailure);
    }
}

function editsToJS(correction) {
    return correction.edits.map(({ startIndex, length, newText, comment }) => ({
        startIndex,
        length,
        newText,
        comment
    }));
}

function* doCreateCorrection(correction) {
    const edits = editsToJS(correction);
    return yield call(doSubmitCorrectionQuery, {
        body: correction.body,
        edits: edits.toJS(),
        postId: correction.postId,
        comment: ""
    });
}

function* doEditCorrection(correction) {
    const edits = editsToJS(correction);
    return yield call(doEditCorrectionQuery, {
        id: correction.id,
        body: correction.body,
        edits: edits.toJS(),
        comment: correction.comment
    });
}

function* doEditComment(correction) {
    return yield call(doEditCorrectionQuery, {
        id: correction.id,
        edits: [],
        comment: correction.comment
    });
}

function* doSubmitCorrection({ payload: { correction } }) {
    try {
        let c;
        if (!correction.id && correction.body) {
            c = yield call(doCreateCorrection, correction);
        } else if (correction.body) {
            c = yield call(doEditCorrection, correction);
        } else if (correction.id) {
            c = yield call(doEditComment, correction);
        } else {
            throw new Error("Invalid input");
        }

        yield put(submitCorrectionSuccess({ correction: c }));
    } catch (e) {
        yield call(handleFailure, e, submitCorrectionFailure);
    }
}

function* doEditCorrectionQuery(params) {
    const query = new Query("mutation").find(
        new Query("updateCorrection", params).find(commentFindContents())
    );
    const { updateCorrection: correction } = yield call(
        doGraphQLQuery,
        query.toString()
    );
    return jsToCorrectionRecord(correction);
}

function* doSubmitCorrectionQuery(params) {
    const query = new Query("mutation").find(
        new Query("createCorrection", params).find(commentFindContents())
    );
    const { createCorrection: correction } = yield call(
        doGraphQLQuery,
        query.toString()
    );
    return jsToCorrectionRecord(correction);
}

function* doDeleteCorrection({ payload: { correction } }) {
    try {
        const query = `mutation {
            deleteCorrection(
                id: ${JSON.stringify(correction.id)}
            )
        }`;
        yield call(doGraphQLQuery, query);
        yield put(deleteCorrectionSuccess({ correction }));
    } catch (e) {
        yield call(handleFailure, e, deleteCorrectionFailure);
    }
}

function* doReportCorrection({ payload: { correction } }) {
    try {
        const query = `mutation {
            reportCorrection(
                id: ${JSON.stringify(correction.id)}
            )
        }`;
        yield call(doGraphQLQuery, query);
        yield put(reportCorrectionSuccess({ correction }));
    } catch (e) {
        yield call(handleFailure, e, reportCorrectionFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/correction.saga.js